import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';
import statusIndex from './status-index';

Router.get('grant/status', statusIndex);
Router.get('grant/status/:any', form);
Router.get('grant/manager', index);
